import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Banking = () => <VerticalPage config={VERTICALS['banking']} />;

export default Banking;
